<div class="content content-more-margin desktop-wide">
  <h1>{{ i18n.langString("data_protection_title") }}</h1>

  @for (item of contentSections; track item.key) {
    @if (item.type === "h3") {
      <h3 id="{{ item.key }}">{{ i18n.langString(item.key!) }}</h3>
    }

    @if (item.type === "h4") {
      <h4 id="{{ item.key }}">{{ i18n.langString(item.key!) }}</h4>
    }

    @if (item.type === "paragraph") {
      @if (item.usKey) {
        @if (showUSCountryPage()) {
          <p [class]="item.class">{{ i18n.langString(item.usKey) }}</p>
        } @else {
          <p [class]="item.class">{{ i18n.langString(item.key!) }}</p>
        }
      } @else {
        <p [class]="item.class">{{ i18n.langString(item.key!) }}</p>
      }
    }

    @if (item.type === "special" && item.key === "consent_block") {
      <p>
        <span class="consent-content">{{
          i18n.langString("consent_content")
        }}</span>
      </p>
      @for (subItem of item.items; track subItem.key) {
        @if (subItem.key === "consent_content_p3") {
          <p>
            <span class="consent-content">{{
              i18n.langString("consent_content3")
            }}</span>
            <span>{{ i18n.langString("consent_content4") }}</span>
            <span class="consent-content">{{
              i18n.langString("consent_content5")
            }}</span>
            <span>{{ i18n.langString("consent_content6") }}</span>
          </p>
        } @else if (subItem.class !== "complex-p") {
          <p>{{ i18n.langString(subItem.key!) }}</p>
        }
      }
    }
  }

  <div class="back-btn">
    <app-nav-button
      [darksecondary]="true"
      svgIcon="icons:arrow-left"
      (clickEvent)="gotoLogin()"
    >
      {{ i18n.langString("back") }}
    </app-nav-button>
  </div>

  <app-scroll-to-top></app-scroll-to-top>
</div>
